<template lang="pug">
router-view
</template>

<script>
// @ is an alias to /src
import DefaultLayout from '@/layouts/DefaultLayout'

export default {
  name: 'home',
  created () {
    this.$emit('update:layout', DefaultLayout)
  }
}
</script>
